import React, { Component } from "react";
import { Form, FormGroup } from "react-bootstrap";
import SpinnerButton from "../../../Components/SpinnerButton";
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { PageTitle } from "../../../../_metronic/layout/core";
import { EntrevistaDetallesHeader } from "./detallesHeader";


const API_URL = process.env.REACT_APP_API_URL
let auth

const entrevistaInitState = {
  _id: "",
    clasificacion: "",
    infoAdicional: "",
    tipoMaterialAdicional: "",
    materialAdicional: "",
    sesiones: "",
    duracion: "",
    tipoEntrevista: "",
    tipoTestimoniante: "",
    transcriptor: "",
    entrevistador: "",
    emi: "",
    colectivo: "",
    grupoMilitancia: "",
    tlaxcoaque: "",
    lugar: "",
    entidad: "",
    fecha: "",
    persona: { _id: "", nombre: "" },
    personaNew: { _id: "", nombre: "", primerApellido: "", segundoApellido: "" },
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class Detalles extends Component {

  constructor(props) {
    super(props)
    this.state = { data: [], persona: [], entrevista: [] }
    this.mam = []
    auth = JSON.parse(localStorage.getItem("kt-auth-react-v"))
    const { currentUser } = this.props;
    this.currentUser = currentUser;
  }

  async componentDidMount() {
    try {
      const response = await fetch(`${API_URL}/entrevista/getById`, {
        method: 'POST',
        body: JSON.stringify({ "id": this.props.params.id }),
        headers: {
          'Content-Type': 'application/json',
          'auth-token': auth.api_token,
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const entrevista = await response.json();
      entrevista.fecha = moment(entrevista.fecha).format("yyyy-MM-D")
      await this.setState({ data: entrevista });
      this.getPersona(entrevista.persona[0]._id)
    } catch (err) {
      console.log(err.message);
    };
  }

  onChange(e) {
    const oldData = [...this.state.entrevista];
    const newData = oldData.filter(item => item.key !== e.target.id);
    newData.push({ key: e.target.id, value: e.target.value });
    this.setState({ entrevista: newData });
  }

  async getPersona(id) {
    try {
      const response = await fetch(`${API_URL}/persona/getById`, {
        method: 'POST',
        body: JSON.stringify({ "id": id }),
        headers: {
          'Content-Type': 'application/json',
          'auth-token': auth.api_token,
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const dataPersona = await response.json();
      await this.setState({ persona: dataPersona });
    } catch (err) {
      console.log(err.message);
    };
  }

  render() {
    return (
      <>
        <PageTitle>Detalles de la Entrevista</PageTitle>
        <div className='card mb-5 mb-xl-10'>
          <div className="card-header">
            <EntrevistaDetallesHeader id={this.props.params.id} />
          </div>
          <div id='kt_account_profile_details'>
            <Form className='form'>
              <Form.Group controlId="entrevistaId">
                <Form.Control type="hidden" defaultValue={this.state.data._id} />
              </Form.Group>
              <div className='card-body border-top p-9'>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Clasificación</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="clasificacion">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Clasificación" defaultValue={this.state.data.clasificacion} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Fecha</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="fecha">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="date" placeholder="Fecha" defaultValue={this.state.data.fecha} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Entidad</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="entidad">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Entidad" defaultValue={this.state.data.entidad} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Lugar</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="lugar">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Lugar" defaultValue={this.state.data.lugar} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Proyecto Tlaxcoaque</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="tlaxcoaque">
                          <Form.Select onChange={(e) => { this.onChange(e) }} value={this.state.data.tlaxcoaque} defaultValue={this.state.data.tlaxcoaque}>
                            <option value="No">No</option>
                            <option value="Si">Si</option>
                          </Form.Select>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Nombre completo</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-4 fv-row'>
                        <FormGroup controlId="nombre">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Nombre" defaultValue={this.state.persona.nombre} />
                        </FormGroup>
                      </div>
                      <div className='col-lg-4 fv-row'>
                        <FormGroup controlId="primerApellido">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Primer Apellido" defaultValue={this.state.persona.primerApellido} />
                        </FormGroup>
                      </div>
                      <div className='col-lg-4 fv-row'>
                        <FormGroup controlId="segundoApellido">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Segundo Apellido" defaultValue={this.state.persona.segundoApellido} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Grupo de Militancia</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="grupoMilitancia">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Grupo Militancia" defaultValue={this.state.data.grupoMilitancia} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Pertenecía a Colectivo</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="colectivo">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Pertenecía Colectivo" defaultValue={this.state.data.colectivo} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>EMI responsable del testimonio</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="emi">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="EMI Responsable" defaultValue={this.state.data.emi} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Entrevistador.a (E) / Asistente (A)</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="entrevistador">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Entrevistador/Asistente" defaultValue={this.state.data.entrevistador} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Transcriptor</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="transcriptor">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Transcriptor" defaultValue={this.state.data.transcriptor} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Tipo de Testimoniante</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="tipoTestimoniante">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Tipo Testimoniante" defaultValue={this.state.data.tipoTestimoniante} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Tipo de Entrevista</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="tipoEntrevista">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Tipo Entrevista" defaultValue={this.state.data.tipoEntrevista} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Duración</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="duracion">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Duracion" defaultValue={this.state.data.duracion} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Sesiones</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="sesiones">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Sesiones" defaultValue={this.state.data.sesiones} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Se recibió material adicional</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="materialAdicional">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Material Adicional" defaultValue={this.state.data.materialAdicional} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Tipo de material recibido</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="tipoMaterial">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Tipo Material" defaultValue={this.state.data.tipoMaterialAdicional} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Información Adicional</label>
                  <div className='col-lg-8'>
                    <div className='row'>
                      <div className='col-lg-12 fv-row'>
                        <FormGroup controlId="infoAdicional">
                          <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Información Adicional" defaultValue={this.state.data.infoAdicional} />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {
              this.currentUser.currentUser.role !== 3 &&
              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <SpinnerButton onClick={() => alert("Guardando")}>Guardar</SpinnerButton>
              </div>
              }
            </Form>
          </div>
        </div>
      </>
    )
  }
}

export default withParams(Detalles)